import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Container, GoalBlock, Icon, Loader,
} from '../../ui-kit';
import './styles.scss';

const HomeView = (props) => (
  <>
    <GoalBlock
      applicants={props.statistic.data.applicants}
      companies={props.statistic.data.companies}
      freelancers={props.statistic.data.freelancers}
      auditions={props.statistic.data.castings}
      recruiters={props.statistic.data.recruiters}
      loading={props.statistic.loading}
      weekApplicants={props.statistic.data.weekApplicants}
      weekRecruiters={props.statistic.data.weekRecruiters}
      weekCastings={props.statistic.data.weekCastings}
      weekFreelancers={props.statistic.data.weekFreelancers}
      weekCompanies={props.statistic.data.weekCompanies}
    />
    <div className="tabs__container">
      <div className="tab">
        <Container>
          <div className="tab_icon__container">
            <Icon name="bi-shop" />
          </div>
          <div className="content__container">
            <p className="title">
              Number of companies awaiting for moderation
            </p>
            <Link to="/companies">Show</Link>
          </div>
          <p className="count">
            {props.statistic.loading ? (<Loader type="small-loader" />) : props.statistic.data.moderatedCompanies}
          </p>
        </Container>
      </div>
      <div className="tab">
        <Container>
          <div className="tab_icon__container">
            <Icon name="exclamation" />
          </div>
          <div className="content__container">
            <p className="title">
              Number of pending complaints
            </p>
            <Link to="/users">Show</Link>
          </div>
          <p className="count">
            {props.statistic.loading ? (<Loader type="small-loader" />) : 0}
          </p>
        </Container>
      </div>
      <div className="tab">
        <Container>
          <div className="tab_icon__container">
            <Icon name="hourglass-split" />
          </div>
          <div className="content__container">
            <p className="title">
              Number of castings awaiting for moderation
            </p>
            <Link to="/offers">Show</Link>
          </div>
          <p className="count">
            {props.statistic.loading ? (<Loader type="small-loader" />) : props.statistic.data.moderatedCastings}
          </p>
        </Container>
      </div>
    </div>
  </>
);

HomeView.propTypes = {
  statistic: PropTypes.object,
};
HomeView.defaultProps = {
  statistic: null,
};

export default HomeView;
